require('../polifills');
require('../assets');
require('../bootstrap');
require('../helpers');
require('../libraries/hoverintent');
require('../layout/header.js');
require('../events.js');
require('../libraries/lazysize');

try {
    let referrers = localStorage.getItem('referrers'),
        previous = localStorage.getItem('previous');

    localStorage.setItem('previous', window.location.href);

    if (referrers) {
        referrers = referrers.split('|');
        let referrer = referrers.pop();

        if (!(referrer === window.location.href || referrer === previous)) {
            localStorage.removeItem("referrers");
        }
        if (Platform.is.ios && referrer === previous) {
            localStorage.removeItem("referrers");
        }
    }
} catch (e) {
    console.log('error in change history');
}
